// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"298":"c82c765d","490":"103f37b3","821":"103f37b3","988":"103f37b3"}[chunkId] + ".css";
};